export enum ButtonTextSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg'
}
